module.exports = __webpack_public_path__ + "statics/img/cate8-2@2x.a01aff71.png";